import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/images/rabta logo.png";

export default function TermsConditions() {
  const navigate = useNavigate();

  return (
    <div className="terms-container">
      <div className="terms-content">
        <div className="terms-header">
          <h1>Terms and Conditions</h1>
        </div>

        <ol className="terms-list">
          <li>
            THIS ACTIVITY WILL START ON 11<sup>th</sup> DECEMBER, 2025 AT 12:00 PM AND END ON 20
            <sup>th</sup> JANUARY, 2026 AT 11:59 PM (<strong>“CONTEST PERIOD”</strong>). NO ENTRY OR
            REGISTRATION WILL BE ENTERTAINED AFTER 11:59 PM OF 20
            <sup>th</sup> JANUARY, 2026.
          </li>

          <li>
            THIS ACTIVITY IS OPEN ONLY TO PERSONS OF AGE 18 (EIGHTEEN) YEARS AND ABOVE, AS ON 11
            <sup>th</sup> DECEMBER, 2025. PARTICIPATION IN THIS ACTIVITY IS PURELY VOLUNTARY.
            PARTICIPATION IN THIS ACTIVITY IMPLIES UNCONDITIONAL ACCEPTANCE OF THESE TERMS AND
            CONDITIONS.
          </li>

          <li>
            THIS ACTIVITY IS OPEN FOR THE RESIDENTS OF THE UNION TERRITORY OF JAMMU &amp; KASHMIR
            ONLY.
          </li>

          <li>
            THIS ACTIVITY IS NOT APPLICABLE IN OR FOR THE RESIDENTS OF THE STATE OF TAMIL NADU. ANY
            PARTICIPATION RECEIVED FROM THE RESIDENTS OF TAMIL NADU OR RESIDENTS OF STATES OR UNION
            TERRITORIES OTHER THAN THOSE SPECIFIED ABOVE WILL NOT BE CONSIDERED. PARTICIPATION IN
            THIS ACTIVITY WILL BE TREATED AS VOID AB INITIO WHEREVER SUCH ACTIVITIES ARE
            SPECIFICALLY PROHIBITED UNDER LOCAL LAWS.
          </li>

          <li>THIS PACKAGE IS ALSO AVAILABLE WITHOUT THIS ACTIVITY.</li>

          <li>
            THE ELIGIBLE PARTICIPANTS WHO INTEND TO PARTICIPATE IN THIS ACTIVITY SHALL SCAN THE QR
            CODE MENTIONED ON THE PACKAGING INSERT OR GIVE A MISSED CALL ON{" "}
            <strong>8100881008</strong> TO RECEIVE A MICROSITE LINK VIA SMS. THE ELIGIBLE
            INDIVIDUALS SHOULD THEN REGISTER THEMSELVES BY ENTERING THEIR NAME, AGE, MOBILE NUMBER,
            STATE, OTP VERIFICATION, RETAILER UNIQUE CODE AND THE UNIQUE CODE MENTIONED ON THE
            PACKAGING INSERT, TO PARTICIPATE IN THE CONTEST.
          </li>

          <li>
            ALL ELIGIBLE INDIVIDUALS SHALL, AFTER REGISTERING THEMSELVES, ENTER THE “RAABTA THEME
            PUZZLE” CONTEST. ONCE REGISTERED, ELIGIBLE PARTICIPANTS CAN, BY ENTERING THEIR
            REGISTERED MOBILE NUMBER AND OTP VERIFICATION, PLAY THE GAME ONCE PER UNIQUE CODE. THE
            WINNERS WILL BE DECIDED ON THE BASIS OF TIME TAKEN TO FINISH THE PUZZLE. EACH
            PARTICIPANT WILL BE ALLOWED ONLY ONE (1) VALID ENTRY FOR EACH UNIQUE CODE.
          </li>

          <li>
            THE WINNERS WILL BE GRATIFIED AS PER BELOW:
            <ul className="sub-list">
              <li>MEGA REWARDS FOR TOP PARTICIPANTS WITH FASTEST TIME.</li>
              <li>
                ON A DAILY BASIS DURING THE CONTEST, ALL PARTICIPANTS COMPLETING THE PUZZLE WITHIN
                60 (SIXTY) SECONDS WILL GET A CASHBACK. HOWEVER, NO REGISTERED PARTICIPANT SHALL WIN
                THE DAILY PRIZE TWICE ON THE SAME DAY.
              </li>
            </ul>
          </li>

          <li>
            THE WINNERS OF DAILY REWARDS SHALL BE INFORMED OF THE CASHBACK THEY HAVE WON THROUGH SMS
            WITHIN 24 (TWENTY-FOUR) HOURS AFTER THE END OF THE DAY OF THEIR PARTICIPATION IN THE
            CONTEST.
          </li>

          <li>
            THE WINNERS OF THE MEGA PRIZES SHALL BE INFORMED ABOUT THE REWARDS THEY HAVE WON THROUGH
            SMS BY 10
            <sup>th</sup> FEBRUARY, 2026 ON OR BEFORE 12:00 PM.
          </li>

          <li>
            ALL VALID ENTRIES REGISTERING WITH A UNIQUE CODE AND PARTICIPATING IN THE ACTIVITY SHALL
            RECEIVE AN ASSURED REWARD OF A CUSTOMISED WALLPAPER ON THE THEME OF “RAABTA CONTEST”
            AFTER COMPLETION OF THE PUZZLE.
          </li>

          <li>
            THE PRIZE(S) SHALL BE GIVEN TO THE RESPECTIVE WINNING PARTICIPANTS, SUBJECT TO THE
            WINNER PRESENTING THE ORIGINAL PACKAGING INSERT, A VALID PROOF OF IDENTITY, ADDRESS AND
            AGE. A DAMAGED OR ILLEGIBLE PACKAGING INSERT MAY BE REJECTED.
          </li>

          <li>
            ITC LIMITED (<strong>“ITC”</strong>) SHALL NOT BE LIABLE FOR NON-RECEIPT OF THE PRIZE
            DUE TO INCORRECT DETAILS PROVIDED BY THE WINNER. NO ADDITIONAL CLAIM SHALL BE
            ENTERTAINED.
          </li>

          <li>
            THERE IS NO WARRANTY OR ASSURANCE AS TO THE QUALITY OF PRIZES WON. THE PRIZES IN OUR
            COMMUNICATION ARE MEANT FOR ILLUSTRATION PURPOSE ONLY; ACTUAL PRIZES MAY DIFFER. THE
            ACTUAL PRIZE(S) WON MAY DIFFER IN SIZE, SHAPE OR COLOUR AS COMPARED TO THE ONES DEPICTED
            IN COMMUNICATIONS. THE PRIZE(S) WON IS NON-TRANSFERABLE AND CANNOT BE EXCHANGED OR
            REDEEMED FOR CASH.
          </li>

          <li>
            THE PARTICIPANTS MUST NOT SUBMIT UNLAWFUL, INACCURATE, MISLEADING, OFFENSIVE, ABUSIVE,
            PORNOGRAPHIC, HARASSING, BLASPHEMOUS, LIBELLOUS, DEFAMATORY, OBSCENE, HATEFUL, RACIALLY
            OR ETHNICALLY OBJECTIONABLE, DISPARAGING OR OTHERWISE INAPPROPRIATE MATERIAL AND AGREES
            TO OBTAIN ANY CONSENT(S), PERMISSION(S) OR LICENSE(S) THAT MAY BE LEGALLY REQUIRED TO
            SUBMIT ANY MATERIAL OR CONTENT AND RESPECT THE PRIVACY OF OTHERS.
          </li>

          <li>
            ITC RESERVES THE RIGHT TO REJECT THE CLAIM IF ANY OF THE TERMS OR CONDITIONS ARE NOT
            MET. ITC WILL NOT BE LIABLE IN ANY MANNER FOR ANY CLAIM ARISING OUT OF OR IN RESPECT OF
            THIS ACTIVITY.
          </li>

          <li>
            ITC UNILATERALLY RESERVES THE RIGHT TO CHANGE THE TERMS AND CONDITIONS OF THIS ACTIVITY
            INCLUDING EXTENDING, WITHDRAWING, OR DISCONTINUING THE SAME WITHOUT NOTICE OR ASSIGNING
            ANY REASON, AT ITS SOLE DISCRETION AND WITHOUT ANY LIABILITY.
          </li>

          <li>
            ALL THE INTELLECTUAL PROPERTY RIGHTS (<strong>“IPR”</strong>) ASSOCIATED WITH THE
            DESIGNS SUBMITTED BY THE PARTICIPANTS SHALL VEST WITH ITC, AND BY PARTICIPATING IN THIS
            ACTIVITY, THE PARTICIPANTS UNDERTAKE AND ASSURE NOT TO MAKE ANY SUCH CLAIMS IN ANY
            PROCEEDINGS OR OTHERWISE.
          </li>

          <li>
            BY PARTICIPATING IN THIS ACTIVITY, THE PARTICIPANTS CONSENT TO COLLECTION, STORING,
            PROCESSING AND USE OF PERSONAL INFORMATION OF THE PARTICIPANTS BY ITC AND ITS SERVICE
            PROVIDERS.
          </li>

          <li>
            THIS ACTIVITY SHALL BE GOVERNED BY THE PRIVACY POLICY OF ITC PUBLISHED HERE:{" "}
            <a
              href="https://www.itcportal.com/about-itc/policies/privacy-policy.aspx"
              target="_blank"
              rel="noopener noreferrer"
              className="privacy-link"
            >
              https://www.itcportal.com/about-itc/policies/privacy-policy.aspx
            </a>
          </li>

          <li>
            EMPLOYEES OF ITC AND THEIR FAMILY MEMBERS ARE NOT ELIGIBLE TO PARTICIPATE IN THIS
            ACTIVITY.
          </li>

          <li>ALL DISPUTES ARE SUBJECT TO THE EXCLUSIVE JURISDICTION OF THE COURTS AT KOLKATA.</li>
        </ol>
      </div>
    </div>
  );
}
